import React, { useState, useEffect, Suspense } from "react";
import { Link } from "react-router";
import { ApiNews as api } from "../../../services/ApiNews";
import APIError from "../../../models/ApiError";
import { useNavigate } from "react-router";
import { formatDate } from "../../../utils/utils";

const NewsCard = ({ id, title, imgUrl, tags, date }) => (
  <div className="card">
    {imgUrl ? (
      <img className="card-img" src={imgUrl} alt={title} />
    ) : (
      <div
        className="card-img card-img-placeholder"
        style={{
          background:
            "linear-gradient(0deg, #fcfcfc 25%, #f8f8f8 50%, #f1f1f1 75%)",
        }}
      />
    )}
    <div className="card-body">
      <div className="card-badges">
        {tags.map((tag) => (
          <span key={tag.id} className="badge badge-default">
            {tag.descripcion}
          </span>
        ))}
      </div>
      <h3 className="card-title">
        <span className="text-dark ellipsis-3">{title}</span>
      </h3>
      <div className="card-info mt-auto">
        <small>
          <span>{date}</span>
        </small>
      </div>
    </div>
    <div className="mt-4 ms-4 mb-3 d-flex justify-content-between gap-2 align-items-center">
      <div>
        <Link to={`/Novedad/${id}`} className="access text-primary ">
          Ver más
        </Link>
      </div>
    </div>
  </div>
);

function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();

    const loadArticles = async () => {
      try {
        const articles = await api.getArticles({
          signal: controller.signal,
          params: {
            page: 1,
            page_size: 3,
          },
        });
        setNews(articles.news || []);
      } catch (error) {
        if (error.name === "CanceledError" || error.name === "AbortError") {
          return;
        }

        if (error instanceof APIError) {
          console.error(`Error ${error.status}: ${error.message}`);
        } else {
          console.error("An unexpected error occurred", error);
        }
      } finally {
        setLoading(false);
      }
    };

    loadArticles();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <div className="container">
      <h4 className="mb-5">Novedades</h4>
      <div className="row g-4 mb-5">
        {loading ? (
          <p>Cargando noticias...</p>
        ) : (
          <div className="has-card-items">
            {/* <div className="responsive-scroll has-card-items"> */}
            <div className="card-items-3">
              <Suspense fallback={<p>Cargando...</p>}>
                {news.map((article, index) => (
                  <div className="col">
                    <NewsCard
                      key={index}
                      id={article.id}
                      title={article.titulo}
                      imgUrl={article.imagen}
                      tags={article.etiquetas}
                      date={formatDate(article.fecha_alta.formato_iso)}
                    />
                  </div>
                ))}
              </Suspense>
            </div>
          </div>
        )}
      </div>
      <Link className="access text-primary " to="/Novedades">
        Ver todas las novedades
      </Link>
    </div>
  );
}

export default News;
